import { InputHTMLAttributes } from 'react';
import * as S from './styled';

interface TextAreaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  errorMessage?: boolean;
}
const TextArea = ({
  label,
  errorMessage = true,
  error,
  disabled = false,
  ...rest
}: TextAreaProps) => {
  const hasError = !!error;
  return (
    <S.TextAreaContainer>
      <S.TextAreaLabel
        $hasError={hasError}
        color={disabled ? '#888888' : 'black'}
      >
        {label}
      </S.TextAreaLabel>
      <S.TextArea
        disabled={disabled}
        color={disabled ? '#888888' : 'black'}
        {...rest}
      />
      {errorMessage && <S.Message $hasError={hasError}>{error}</S.Message>}
    </S.TextAreaContainer>
  );
};

export default TextArea;
